var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50cc85;}.cls-2{fill:#fff5cc;}.cls-3{fill:#53b8e5;}.cls-4{fill:#dbe5e5;}.cls-10,.cls-20,.cls-5,.cls-6{fill:#a8c0c8;}.cls-12,.cls-5{opacity:0.3;}.cls-6{opacity:0.15;}.cls-7{opacity:0.04;}.cls-19,.cls-8{fill:#1b434c;}.cls-11,.cls-13,.cls-23,.cls-9{fill:none;stroke-miterlimit:10;}.cls-9{stroke:#dbe5e5;}.cls-11,.cls-13,.cls-9{stroke-width:6.71px;}.cls-11,.cls-13{stroke:#a8c0c8;}.cls-11,.cls-15{opacity:0.4;}.cls-12,.cls-17{fill:#266275;}.cls-14{fill:#93a4ab;}.cls-15{fill:#6d8186;}.cls-16{fill:#ffcc01;}.cls-18{fill:#fff;}.cls-19,.cls-20{opacity:0.5;}.cls-21{fill:#e8f5f4;}.cls-22{fill:#91e6e1;opacity:0.41;}.cls-23{stroke:#1b434c;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right_arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.49,224.7s-1.81-6.46-1.14-6.46,4.81,4.25,5.29,4.25c.68,0,2.26-7.59,3-7.59.88,0,5.63,7.24,6.22,7.24s3.1-3.41,3.71-3.41c.76,0,.61,6,.61,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112,224.26s1.81-6.47,1.14-6.47-4.82,4.26-5.29,4.26c-.68,0-2.27-7.59-3-7.59-.88,0-5.64,7.24-6.22,7.24s-3.1-3.41-3.71-3.41c-.76,0-.62,6-.62,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116,154.41S174.81,200,207.77,157,154.7,78,118.67,106.79C101,121,100.6,141.68,116,154.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.22,255.64s35.18-2.33,40.57,2.27,5,4.26,12.59,4.92,12.41,3.94,5.23,8.53,23,7.38,37.12,7.63,20.7,10.75-32.81,2.88S81.08,264.45,71,264.45C49,264.45,55.49,256.4,60.22,255.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.86,261l9.92-4.09s17.84-15.49,6.56-14.48-11,3.45-10,5.31,1.34,3.19-3,6.58-3.81,5.62-3.81,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112,251.71c0,3.51-12.28,6.36-27.43,6.36s-21-2.85-21-6.36,5.86-6.37,21-6.37S112,248.19,112,251.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219,241.81c-37.87,0-49.84,5.91-31.62,10.88s25.12,8.08,2.59,11.52-76.57,2.65-55.13,7.81c11.4,2.74,53.89-.18,78,5.58s58.83-7.88,36.06-13.13c-23.3-5.37-20.36-13.67,2.65-13.67C275.49,250.8,268.76,241.81,219,241.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.63,230.86v6.3H61.86V226.37c1.58-2,4.81-.36,7-1.49a3.09,3.09,0,0,0,1.24-1.18H249.65c2.23,3.62,7.56-.7,8.89,4A3.92,3.92,0,0,0,261.63,230.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 61.86,
    y: 232.2,
    width: 199.78,
    height: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.87,241.81c30,0,63.69-.45,67.7,3.46s-8.45,8,14.29,10.49-37.19,6.51-53.93,2-5.11-8.95-28.08-9.43C70,247.85,42.79,241.81,93.87,241.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.11,233.27H61.86v-6.9c1.58-2,4.81-.36,7-1.49A10.62,10.62,0,0,1,73,227.41c3.59,3.78,6.94-4,18.28-.37,10.8,3.48,23.28-1.4,35.9,5.15C127.84,232.52,128.48,232.88,129.11,233.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M106.16,224.71V236.2H94.43V224.71h11.73m.9-.9H93.53V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.63,224.71V236.2H80.89V224.71H92.63m.9-.9H80V237.1H93.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M119.7,224.71V236.2H108V224.71H119.7m.9-.9H107.06V237.1H120.6V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.23,224.71V236.2H121.5V224.71h11.73m.9-.9H120.6V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.77,224.71V236.2H135V224.71h11.74m.9-.9H134.13V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.3,224.71V236.2H148.57V224.71H160.3m.9-.9H147.67V237.1H161.2V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M173.84,224.71V236.2H162.1V224.71h11.74m.9-.9H161.2V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.38,224.71V236.2H175.64V224.71h11.74m.9-.9H174.74V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M200.91,224.71V236.2H189.17V224.71h11.74m.9-.9H188.28V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M214.45,224.71V236.2H202.71V224.71h11.74m.9-.9H201.81V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228,224.71V236.2H216.25V224.71H228m.9-.9H215.35V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M241.52,224.71V236.2H229.78V224.71h11.74m.9-.9H228.88V237.1h13.54V223.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.59,261.55s-7.56-3.46.11-5c3.31-.67,3.61.52,24.24,2.53S117,247.89,117,247.89l-5-.84s-10,5.39-10.62,5.75-2.51,1.19-3.07,2.47,0,5.13,0,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.63,230.86v6.3H61.86V226.37c1.58-2,4.81-.36,7-1.49a3.09,3.09,0,0,0,1.24-1.18H249.65c2.23,3.62,7.56-.7,8.89,4A3.92,3.92,0,0,0,261.63,230.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 61.86,
    y: 232.2,
    width: 199.78,
    height: 4.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.11,233.27H61.86v-6.9c1.58-2,4.81-.36,7-1.49A10.62,10.62,0,0,1,73,227.41c3.59,3.78,6.94-4,18.28-.37,10.8,3.48,23.28-1.4,35.9,5.15C127.84,232.52,128.48,232.88,129.11,233.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M106.16,224.71V236.2H94.43V224.71h11.73m.9-.9H93.53V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.63,224.71V236.2H80.89V224.71H92.63m.9-.9H80V237.1H93.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M119.7,224.71V236.2H108V224.71H119.7m.9-.9H107.06V237.1H120.6V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.23,224.71V236.2H121.5V224.71h11.73m.9-.9H120.6V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.77,224.71V236.2H135V224.71h11.74m.9-.9H134.13V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.3,224.71V236.2H148.57V224.71H160.3m.9-.9H147.67V237.1H161.2V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M173.84,224.71V236.2H162.1V224.71h11.74m.9-.9H161.2V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187.38,224.71V236.2H175.64V224.71h11.74m.9-.9H174.74V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M200.91,224.71V236.2H189.17V224.71h11.74m.9-.9H188.28V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M214.45,224.71V236.2H202.71V224.71h11.74m.9-.9H201.81V237.1h13.54V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228,224.71V236.2H216.25V224.71H228m.9-.9H215.35V237.1h13.53V223.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M241.52,224.71V236.2H229.78V224.71h11.74m.9-.9H228.88V237.1h13.54V223.81Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "177.48 167.15 174.92 199.7 168.34 221.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 171.14,
    y: 210.65,
    width: 6.56,
    height: 18.96,
    rx: 3.28,
    transform: "translate(-46.24 393.89) rotate(-89.83)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 176.73,
    y1: 176.17,
    x2: 175.48,
    y2: 191.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "146.07 165.63 146.56 198.28 151.72 220.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 137.05,
    y: 216.85,
    width: 18.96,
    height: 6.56,
    rx: 3.28,
    transform: "matrix(1, 0, 0, 1, -0.67, 0.44)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 146.25,
    y1: 174.69,
    x2: 146.49,
    y2: 190.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.58,159.37s1.19,21.84,2.3,22.95,15.18,2.81,16.76,1.24c1.23-1.24,5.07-11,6-11,.7,0,3.68,8.17,5.46,10s15.39,1.6,16.76.23c1.89-1.89,2.25-23.41,2.25-23.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M149.93,159.37a15.45,15.45,0,0,1-12.62,12.26c-.43-6.19-.73-12.26-.73-12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M186.09,159.37s-.1,6.13-.46,12.29a15.43,15.43,0,0,1-12.77-12.29Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 72.54,
    y1: 138.37,
    x2: 79.66,
    y2: 152.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 70.78,
    y: 122.84,
    width: 7.17,
    height: 67.38,
    transform: "translate(-17.92 9.85) rotate(-6.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 34.78,
    y: 77.26,
    width: 67.4,
    height: 46.26,
    rx: 1.8,
    transform: "translate(-11.35 8.77) rotate(-6.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 67.18,
    y: 123.05,
    width: 7.17,
    height: 6.31,
    transform: "translate(-14.37 9.21) rotate(-6.76)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 250.44,
    y1: 126.2,
    x2: 245.03,
    y2: 141.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "202.71 139.34 228.46 155.38 245.03 141.22 259.59 140.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 202.7,
    y1: 139.34,
    x2: 216.66,
    y2: 148.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M179.53,136l23.22,12.48a2.38,2.38,0,0,0,3.06-.69l6.22-8.48a2.39,2.39,0,0,0-.64-3.44l-18-13.52Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "123.72 141.34 103.6 157.59 79.66 152.66 65.07 153.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 123.72,
    y1: 141.34,
    x2: 110.57,
    y2: 151.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.22,135l-21.29,15.55a2.39,2.39,0,0,1-3.13-.27l-7.32-7.55a2.39,2.39,0,0,1,.16-3.49l15.94-15.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M207.28,44c0,14.65,12.14,28.11,26.78,28.11S263,60.2,263,45.55s-11.88-28.11-26.52-28.11S207.28,29.32,207.28,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M132.9,128.23s-.6,31.32,1.4,33.66,52.24,3.08,55.16.41,3.17-31.9,2.83-32.82S132.9,128.23,132.9,128.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M138.57,128.36v.31s-.7,10,.49,11.23c.74.74,20.39-11.42,20.39-11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M186.2,128.36v.31s.7,10-.48,11.23c-.74.74-20.4-11.42-20.4-11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M165.82,142.55c0,3-1.06,3.8-3,3.8s-3.67-.77-3.81-3.08a3.89,3.89,0,0,1,3.52-4.07A3.19,3.19,0,0,1,165.82,142.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M165.82,154.05c0,3-1.06,3.8-3,3.8s-3.67-.78-3.81-3.08a3.89,3.89,0,0,1,3.52-4.08A3.19,3.19,0,0,1,165.82,154.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M192.4,134.27c-14.24,1.9-44.84.42-59.59-1,0-4.38.08-5,.08-5s59.07.33,59.4,1.25C192.39,129.75,192.45,130.57,192.4,134.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M169,53.6H245.5s-2.56-8.19-11.08-8.19-10.92,3.41-10.92,3.41-2-12.27-17.73-12.27-17.9,10.06-17.9,10.06S176.36,46.18,169,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.51,86.91s6.06-.42,7.06,0,3.52,13.86-1,25c-.48,1.16-6.86,0-6.86,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M210.19,112.41c-1.75-.13-3.53-.46-3.53-.46l.85-25s2.17-.15,4.13-.18A53.68,53.68,0,0,1,210.19,112.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.61,86.91s-6.07-.42-7.07,0-3.52,13.86,1.06,25c.47,1.16,6.85,0,6.85,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M112.92,112.41c1.75-.13,3.53-.46,3.53-.46l-.84-25s-2.18-.15-4.14-.18A53.8,53.8,0,0,0,112.92,112.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M203.54,129.38c-3,3.56-16.79,3-41.46,2.46-24.28-.5-41.08-1.26-43.68-5.32-7.33-11.42-4.83-65.91-2.05-68.7,3.1-3.09,13.1-4.42,23.8-5l.84,0c8.28-.44,14.41-1,20.47-1,5.66.06,13.74.28,21.58.93h0l1,.08c11,.92,20.6,1.89,22.79,5.34C210.64,64.2,209.4,122.5,203.54,129.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M198.62,124.69c-1.36,1.61-5.25,2.25-11.67,2.42,0,0,0,0,0,0-.44,0-.9,0-1.36,0h-.72c-2.15,0-4.55,0-7.18,0-3,0-6.35-.11-10-.19l-5.18-.11c-21.15-.43-35.8-1.1-38.06-4.63a15.71,15.71,0,0,1-1.71-4.2c-2.94-10.48-2.88-32.22-1.85-45.28.46-5.77,1.11-9.85,1.77-10.52,4.9-4.91,27.11-4.7,39.24-4.57s36.66.38,40,5.62c.7,1.1,1.18,4.16,1.47,8.37C204.42,87.55,202.67,119.93,198.62,124.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M198.62,124.69c-1.36,1.61-5.25,2.25-11.67,2.42,0,0,0,0,0,0-.44,0-.9,0-1.36,0h-.72c-2.15,0-4.55,0-7.18,0-3,0-6.35-.11-10-.19l-5.07-.11c-21.16-.43-35.8-1.1-38.07-4.64a17.68,17.68,0,0,1-1.81-4.19c-2.94-10.48-2.88-32.22-1.85-45.28a38.88,38.88,0,0,1,16.42-1.94c9.71,1.34,17.8,6.64,28,6.79s15.48-6.33,23-7.53c9.38-1.47,13.3.74,15,1.58C204.42,87.55,202.67,119.93,198.62,124.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M184,52.85C181,56.79,173.5,64.76,163,64.76c-11,0-19.15-8.47-22-12,8.28-.44,14.41-1,20.47-1,5.66.06,13.74.28,21.58.93h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 147.55,
    cy: 89.91,
    rx: 9.8,
    ry: 3.13,
    transform: "translate(55.44 236.09) rotate(-89.14)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 175.92,
    cy: 90.36,
    rx: 9.8,
    ry: 3.13,
    transform: "translate(82.94 264.9) rotate(-89.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M148.07,110.74a31.94,31.94,0,0,1,29.81-3.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "70.66 103.25 66.82 103.67 63.24 84.01 69.88 83.28 70.66 103.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 69.38,
    cy: 110.12,
    r: 3.43
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportWarning);
export default __webpack_public_path__ + "static/media/report_warning.3170c37dcb91d0c8fbe370c3e82ee95c.svg";
export { ForwardRef as ReactComponent };